<template>
  <div>
    <Modal
        name="DeleteGiveawayModal"
        title="Удаление розыгрыша"
        v-model="isShowDeleteGiveawayModal"
        :params="{ id: selectedGiveawayId }"
        @giveawayDeleted="handleGiveawayDeleted"
    />
    <div class="container-fluid">
      <Breadcrumbs main="Розыгрыши" title="Список розыгрышей"/>
      <b-card>
        <div class="row mb-3 align-items-start">
          <div class="col-12 col-md-9">
            <div class="d-flex flex-wrap align-items-start">
              <div class="mr-3">
                <SearchInput
                    v-model="searchForGiveawaysModel"
                    @search="getFilteredGiveaways()"
                    :placeholder-name="'Поиск розыгрышей'"
                />
                <div class="notification-for-search">Поиск по названию розыгрыша</div>
              </div>
              <b-form-select
                  v-model="currentStatus"
                  :options="giveawayStatusOptions"
                  class="status-select"
                  @change="getFilteredGiveaways()"
              ></b-form-select>
            </div>
          </div>
          <div class="col-12 col-md-3 text-md-right mt-3 mt-md-0">
            <b-button
                variant="primary"
                class="w-100 w-md-auto ml-md-auto"
                :to="{ name: 'create_giveaway' }"
            >
              Создать розыгрыш
            </b-button>
          </div>
        </div>

        <div v-if="isLoading" class="loading-wrapper">
          <b-spinner class="spinner"></b-spinner>
        </div>
        <b-table
            v-else
            responsive
            show-empty
            stacked="md"
            striped
            bordered
            :items="giveaways"
            :fields="fields"
            :current-page="0"
            class="mb-5 table-no-scroll"
            empty-text="Нет доступных розыгрышей"
        >
          <template #cell(game)="data">
            {{ getGiveawayGameTitle(data.item) }}
          </template>
          <template #cell(starts_at)="data">
            {{ formatGiveawayDate(data.item.starts_at) }}
          </template>

          <template #cell(ends_at)="data">
            {{ formatGiveawayDate(data.item.ends_at) }}
          </template>

          <template #cell(coupons)="data">
            <div class="coupons-cell">
              <div class="coupons-cell__text">
                {{ getCouponsActivated(data.item) }} / {{ getCouponsTotal(data.item) }} активировано
              </div>
              <b-progress
                  :value="getCouponsProgress(data.item)"
                  :max="100"
                  height="4px"
                  variant="primary"
              ></b-progress>
            </div>
          </template>

          <template #cell(status)="data">
            <b-badge :variant="getGiveawayStatusVariant(data.item)">
              {{ getGiveawayStatusText(data.item) }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="row justify-content-center">
              <b-btn variant="primary" class="mr-1 p-1" :to="{ name: 'edit_giveaway', params: { id: data.item.id } }" title="Редактировать">
                <i class="fa fa-edit"></i>
              </b-btn>
              <b-btn variant="warning" class="mr-1 p-1" :to="{ name: 'giveaway_details', params: { id: data.item.id } }" title="Купоны и победители">
                <i class="fa fa-eye"></i>
              </b-btn>
              <b-btn variant="danger" class="p-1" @click="confirmDelete(data.item.id)" title="Удалить">
                <i class="fa fa-trash"></i>
              </b-btn>
            </div>
          </template>
        </b-table>
        <b-col md="6" class="p-0">
          <b-pagination
              @change="handlePageChange"
              v-model="currentPage"
              :total-rows="pagination.total"
              :per-page="pagination.perPage"
              class="my-0"
          ></b-pagination>
        </b-col>
      </b-card>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import SearchInput from "@/components/SearchInput.vue";
import Modal from '@/components/modals/index.vue'
import {GiveawayAdapterMixin} from "@/mixins/Giveaways/GiveawayAdapterMixin";

export default {
  name: 'ListGiveaways',
  mixins: [GiveawayAdapterMixin],
  components: {SearchInput, Modal},
  data() {
    return {
      searchForGiveawaysModel: '',
      currentStatus: null,
      fields: [
        {key: 'id', label: '№', sortable: true},
        {key: 'name', label: 'Название', sortable: true},
        {key: 'game', label: 'Игра', sortable: false},
        {key: 'starts_at', label: 'Дата старта', sortable: true},
        {key: 'ends_at', label: 'Дата окончания', sortable: true},
        {key: 'coupons', label: 'Купоны', sortable: false},
        {key: 'status', label: 'Статус', sortable: false},
        {key: 'actions', label: 'Действия', sortable: false}
      ],
      isLoading: false,
      currentPage: 1,
      isShowDeleteGiveawayModal: false,
      selectedGiveawayId: null,
    };
  },
  computed: {
    ...mapGetters('moduleGiveaways', ['getGiveaways', 'getGiveawaysPagination']),
    giveaways() {
      return this.getGiveaways;
    },
    pagination() {
      return this.getGiveawaysPagination;
    }
  },
  mounted() {
    this.loadGiveaways();
  },
  methods: {
    ...mapActions('moduleGiveaways', ['fetchGiveaways']),
    async loadGiveaways() {
      this.isLoading = true;
      try {
        const params = {page: this.currentPage};

        if (this.searchForGiveawaysModel.trim()) {
          params.search = this.searchForGiveawaysModel.trim();
        }

        if (this.currentStatus) {
          params.status = this.currentStatus;
        }

        await this.fetchGiveaways(params);
      } catch (error) {
        console.error('Error loading giveaways:', error);
      } finally {
        this.isLoading = false;
      }
    },
    getFilteredGiveaways() {
      this.currentPage = 1;
      this.$nextTick(() => this.loadGiveaways());
    },
    handlePageChange(pageNumber) {
      this.currentPage = pageNumber;
      this.loadGiveaways();
    },
    confirmDelete(id) {
      this.selectedGiveawayId = id;
      this.isShowDeleteGiveawayModal = true;
    },
    handleGiveawayDeleted() {
      this.isShowDeleteGiveawayModal = false;
      this.selectedGiveawayId = null;
      this.loadGiveaways();
    },
  }
};
</script>

<style scoped>
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.notification-for-search {
  font-size: 0.9em;
  color: #6c757d;
}

.status-select {
  width: 200px;
}

@media screen and (max-width: 500px) {
  .status-select {
    width: 100%;
    margin-top: 10px;
  }
}

.coupons-cell__text {
  margin-bottom: 4px;
  white-space: nowrap;
}

.table-no-scroll {
  overflow-x: hidden !important;
}
</style>
